// Access JWTs are invalidated when the shared HttpOnly refresh cookie rotates.
// Readers may run concurrently, but rotation and its retry must finish together
// before another tab rotates again. No credentials are shared through storage.
export async function withSessionAccess<T>(mode: LockMode, task: () => Promise<T>): Promise<T> {
  if (!navigator.locks) return task();
  return await navigator.locks.request("magistika.browser-session.access.v1", {mode}, task);
}
